import { useState, useMemo, useEffect } from "react";
import { searchPage } from "grandus-lib/utils/fetches";
import { get, isArray, isEmpty, map } from "lodash";
import { Result, Button } from "antd";
import {
  getSearchLinkAttributes,
  getSearchLinkAttributesFromRouter,
  paramsToPath,
} from "grandus-lib/hooks/useFilter";
import { FrownOutlined } from "@ant-design/icons";

import { useRouter } from "next/router";

import Breadcrumbs from "components/breadcrumbs/Breadcrumbs";
import ProductCard from "components/product/card/ProductCard";
import Pagination from "components/pagination/Pagination";
import MetaData from "grandus-lib/components-atomic/MetaData";
import CategoryParameters from "components/category/CategoryParameters";
import CategoryOrdering from "components/category/CategoryOrdering";
import CategorySelected from "components/category/CategorySelected";

import styles from "pages/kategoria/[category]/Category.module.scss";
import TagManager from "grandus-lib/utils/gtag";
import EnhancedEcommerce from "utils/ecommerce";
import Remarketing from "grandus-lib/utils/remarketing";

const handleGetData = (router, newState) => {
  const data = getSearchLinkAttributes(
    get(router, "query.term"),
    paramsToPath(newState),
    get(router, "query"),
    { toDelete: ["term", "parameters", "page"] },
    router
  );

  return data;
};

const handleOrderingLinkAttributes = (router, ordering) => {
  return getSearchLinkAttributesFromRouter(router, {
    dataToChange: { orderBy: ordering },
    toDelete: ["term", "parameters", "page"],
  });
};

const handlePaginationLinkAttributes = (router, data) => {
  return getSearchLinkAttributesFromRouter(router, data);
};

export const JSXCategoryParameters = ({ initialData }) => {
  const [openedFilter, setOpenedFilter] = useState(false);
  const buttonText = openedFilter ? "Zatvoriť filter" : "Filtrovať produkty";
  const toggleFilter = () => {
    if (openedFilter) {
      setOpenedFilter(false);
    } else {
      setOpenedFilter(true);
    }
  };
  return (
    <>
      <Button
        onClick={toggleFilter}
        size={"large"}
        block
        className={styles.filterToggle}
      >
        {buttonText}
      </Button>
      <div className={`${styles.filter} ${openedFilter ? styles.open : ""}`}>
        <Button
          onClick={toggleFilter}
          type={"danger"}
          size={"large"}
          className={styles.filterToggleFixed}
        >
          {buttonText}
        </Button>
        <Button
          onClick={toggleFilter}
          size={"large"}
          block
          className={styles.filterToggle}
        >
          {buttonText}
        </Button>
        <CategoryParameters
          initialData={initialData}
          handleGetData={handleGetData}
        />
      </div>
    </>
  );
};

const Search = ({ products, filter, meta, pagination }) => {
  const router = useRouter();

  useEffect(() => {
    TagManager.push(EnhancedEcommerce.impressions(products, 'search'));
    TagManager.push(Remarketing.viewSearchResults(products));
  })
  return (
    <>
      <MetaData {...meta} />
      <main className={styles.categoryPage} style={{ paddingBottom: "50px" }}>
        <div className="custom-container">
          <Breadcrumbs current={"Vyhľadávanie"} />

          <div className={styles.categoryWrapper}>
            <aside className={styles.filterSidebar}>
              <JSXCategoryParameters initialData={filter} />
            </aside>

            <section className={styles.productsWrapper}>
              <div className={styles.categoriesWrapper}>
                <h1>Hľadaný výraz: "{get(router, "query.term")}"</h1>

                <div
                  className={[styles.productListing, "productListing"].join(
                    " "
                  )}
                >
                  <div className={[styles.row, "row"].join(" ")}>
                    <div className={"col-12"}>
                      <CategorySelected handleGetData={handleGetData} />
                    </div>
                    <div className={"col-12"}>
                      <CategoryOrdering
                        styles={styles}
                        totalCount={pagination?.totalCount}
                        handleLinkAttributes={handleOrderingLinkAttributes}
                      />
                    </div>
                  </div>

                  {isArray(products) && !isEmpty(products) ? (
                    <>
                      <div className={[styles.row, "row"].join(" ")}>
                        {map(products, (product, index) => {
                          const cardOptions = {
                            style: {
                              wrapperClasses: [styles.box],
                            },
                            eecProduct: {
                              position: index + 1,
                              page: pagination?.currentPage,
                              perPage: pagination?.perPage,
                            },
                          };
                          return (
                            <div className={[styles.column].join(" ")}>
                              <ProductCard {...product} options={cardOptions} />
                            </div>
                          );
                        })}
                      </div>

                      <Pagination
                        {...pagination}
                        handleLinkAttributes={handlePaginationLinkAttributes}
                      />
                    </>
                  ) : (
                    <Result
                      icon={<FrownOutlined />}
                      title="Ľutujeme, nenašli sa produkty"
                      subTitle={`Vášmu výberu nezodpovedaju žiadne produkty. Zmente prosím kategóriu alebo kombináciu filtrov.`}
                    />
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  );
};

export async function getServerSideProps(context) {
  return searchPage.serverSideProps(context);
}

export default Search;
